import axios from 'axios';

export const requestCommand = async (payload) => axios.post(`${process.env.VUE_APP_API_HOST}/api/mews-payment-terminal`, payload);
